import { Container } from "react-bootstrap";
import NavMenu from "./NavMenu";

export default function Layout(props: any) {
  return (
    <div>
      <NavMenu />
      <Container className="pb-5">
        {props.children}
      </Container>
    </div>
  );
}
